import { render, staticRenderFns } from "./M2hSurvey.vue?vue&type=template&id=40989572&scoped=true&"
import script from "./M2hSurvey.vue?vue&type=script&lang=js&"
export * from "./M2hSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40989572",
  null
  
)

export default component.exports